const db = "https://us-central1-cygdisenos-1aad9.cloudfunctions.net/app";
// const db = "http://localhost:5001/cygdisenos-1aad9/us-central1/app";

export default db;
